// extracted by mini-css-extract-plugin
export default {"FileSelector":"FileSelector_FileSelector__B6W-B","DraggedOver":"FileSelector_DraggedOver__tRjh9","UploadIcon":"FileSelector_UploadIcon__kEQ4X"};